<template>
    <section id="features" class="features_area pt-120">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="section_title text-center pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              Quero ser Cliente
            </h4>
            <br />
            <h6
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              Solicite um Orçamento
            </h6>
            <br />
            <p
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              Temos certeza que a organização fiscal, contábil e trabalhista de
              uma empresa, pode gerar resultados bons e ruins dependendo de quem
              executa o processo. Estamos comprometidos em garantir segurança e
              qualidade para sua empresa.
            </p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-7">
          <div
            class="single_features text-center mt-30 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.2s"
          >
            <i class="lni lni-apartment"></i>
            <h4 class="features_title">Abertura de Empresa</h4>
            <ul class="ul-order">
              <li>Planejamento Tributário</li>
              <li>Definição de Natureza Jurídica</li>
              <li>Elaboração de Contrato Social</li>
              <li>Registro Junta Comercial</li>
              <li>Registro Receita Federal (CNPJ)</li>
              <li>Registro Prefeitura (CCM)</li>
              <li>Registro em Conselhos Regionais</li>
              <li>Outros Registros Necessários</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-7">
          <div
            class="single_features text-center mt-30 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.4s"
          >
            <i class="lni lni-consulting"></i>
            <h4 class="features_title">Assessoria Mensais</h4>
            <ul class="ul-order">
              <li>Escrituração Fiscal</li>
              <li>Assessoria Fiscal</li>
              <li>Folha de Pagamento</li>
              <li>Escrituração Contábil</li>
              <li>Consultoria contábil</li>
              <li>Apoio Empresarial</li>
              <li>Contabilidade Completa</li>
              <li>Gestão Financeira</li>
              <li>Todos os Serviços Necessários</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-7">
          <div
            class="single_features text-center mt-30 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.6s"
          >
            <i class="lni lni-invention"></i>
            <h4 class="features_title">Outros Serviços</h4>
            <ul class="ul-order">
              <li>Declaração de Imposto de renda</li>
              <li>Regularização de Contabilidade</li>
              <li>Levantamento de Pendências</li>
              <li>Alterações Contratuais</li>
              <li>Encerramento de Empresa</li>
              <li>Registro em órgãos</li>
              <li>Outros Serviços</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  //props: ['textconteudo', 'icon', 'title'],
};
</script>

<style scoped>

</style>